<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand"
          to="/"
        >
          <span class="brand-logo">
            <b-img
              :src="currentAppLogoImage"
              alt="logo"
            />
          </span>
          <h2 class="brand-text mb-0">
             <span class="brand-logo">
            <b-img
                :src="currentAppNameImage"
                alt="logo"
            />
          </span>
<!--            {{ appName }}-->
          </h2>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appNameImage, appLogoImage, appNameImageDark, appLogoImageDark } = $themeConfig.app
    const { skin } = useAppConfig()
    const currentAppNameImage = computed(() => (skin.value === 'dark' ? appNameImageDark : appNameImage))
    const currentAppLogoImage = computed(() => (skin.value === 'dark' ? appLogoImageDark : appLogoImage))
    return {
      appName,
      currentAppLogoImage,
      currentAppNameImage,
    }
  },
}
</script>

<style>

</style>
